import React, { useContext } from 'react'
import { Button, Spacer, Text, View } from 'oio-react'
import { useRouteMatch } from 'react-router-dom'
import { ViewGlyph12Icon } from 'assets/icons'
import privacyConstants from 'config/constants/privacy'
import { useOrganization } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const SettingsPrivacyBlock = () => {
   const match = useRouteMatch()
   const { organization } = useOrganization()
   const { initiative } = useContext(InitiativeHierarchyContext)
   const currentPrivacyOption = privacyConstants.find(p => p.value === initiative.privacy)

   return (
      <View
         display="flex"
         width="100%"
         padding="30px 20px"
         backgroundColor={currentPrivacyOption.backgroundColor}>
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="24px"
            height="24px"
            backgroundColor={currentPrivacyOption.highlightColor}
            borderRadius="50%"
            flex="0 0 auto"
            marginRight="18px">
            <ViewGlyph12Icon
               width="12px"
               height="12px"
               color="#524439"
               strokeWidth="2px"
            />
         </View>
         <View flex="1 1 auto">
            <View padding="0px 0px 6px 0px">
               <Text size="1.5[a-b] 2[c-f]" color="#524439">
                  {`${initiative.type.nameSingular} Privacy: `}
                  <b>{currentPrivacyOption.name}</b>
                  <View
                     width="100%"
                     borderTop="1px solid rgba(0,0,0,0.1)"
                     marginTop="10px"
                     paddingTop="10px"
                  />
               </Text>
               <Text size="1[a-b] 1.5[c-f]" color="#524439">
                  {/* CUSTOM */}
                  {initiative.privacy === 'custom' && (
                     `This ${initiative.type.nameSingular} currently has custom privacy settings.`
                  )}
                  {/* INHERIT */}
                  {initiative.privacy === 'inherit' && (
                     <>
                        {/* IF OPEN COMMUNITY */}
                        {organization.privacy === 'open' && `Anyone from the Public and the ${organization.name} Community can see and ${initiative.joinVerb} this ${initiative.type.nameSingular}.`}
                        {/* IF EXCLUSIVE COMMUNITY */}
                        {organization.privacy === 'exclusive' && `${organization.name} Community members can see and ${initiative.joinVerb} this ${initiative.type.nameSingular}. Public users can see but not ${initiative.joinVerb} this ${initiative.type.nameSingular}.`}
                        {/* IF SECRET COMMUNITY */}
                        {organization.privacy === 'secret' && `Anyone from the ${organization.name} Community can see and ${initiative.joinVerb} this ${initiative.type.nameSingular}. It is not visible to the public.`}
                     </>
                  )}
                  {/* PRIVATE */}
                  {initiative.privacy === 'private' && (
                     `Only people that are invited can see and join this ${initiative.type.nameSingular}.`
                  )}
                  {/* ADMIN */}
                  {initiative.privacy === 'admin' && (
                     `This ${initiative.type.nameSingular} is only visible to Admins of this ${initiative.type.nameSingular} and the ${organization.name} Community.`
                  )}
                  {/* DRAFT */}
                  {initiative.privacy === 'draft' && (
                     `This ${initiative.type.nameSingular} is only visible to you.`
                  )}
               </Text>
            </View>
            <Spacer size="2" />
            <Button
               linkTo={`${match.url}/people/select-privacy`}
               size="sm"
               width="100%"
               name="Options..."
               color={currentPrivacyOption.highlightColor}
               textColor="#000"
            />
         </View>
      </View>
   )
}

export default SettingsPrivacyBlock
